/* eslint-disable react-hooks/exhaustive-deps */
import { InfoIcon } from '@chakra-ui/icons';
import {
	AlertDialog,
	AlertDialogBody,
	AlertDialogContent,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogOverlay,
	Box,
	Button,
	Input,
	ListItem,
	Popover,
	PopoverArrow,
	PopoverBody,
	PopoverContent,
	PopoverTrigger,
	SimpleGrid,
	Text,
	UnorderedList,
	useDisclosure,
	WrapItem,
} from '@chakra-ui/react';
import { faMinusSquare } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { v4 as uuidv4 } from 'uuid';
import DownloadAndViewButton from '../../../../components/Files/DownloadAndViewButton';
import TempFileUploader from '../../../../components/Files/TempFileUploader';
import LabelDetail from '../../../../components/LabelDetail';

export default function AdditionalAttachment({ initData = [], isEditing = false, onChange = () => null, showLabel = true }) {
	const { t } = useTranslation();
	const [list, setList] = useState(initData || []);
	const [uploadingFile, setUploadingFile] = useState(false);
	const [removingId, setRemovingId] = useState(null);

	useEffect(() => setList(initData), [initData]);

	function addNewFile() {
		const tempFiles = [
			...list,
			{
				no: list?.length === 0 ? 1 : list[list?.length - 1]?.no + 1,
				id: uuidv4(),
				label: '',
				tempFile: null,
				file: null,
				tempPdf: null,
				pdf: null,
			},
		];
		setList(tempFiles);
		onChange(tempFiles);
	}

	function removeFile(id) {
		let tempRes = [];
		list?.forEach((item) => {
			if (id !== item?.id) {
				tempRes.push(item);
			}
		});
		setList(tempRes);
		onChange(tempRes);
	}

	function onLabelChange(id, label) {
		let tempRes = [];
		list?.forEach((item) => {
			if (id === item?.id) {
				tempRes.push({
					...item,
					label,
				});
			} else {
				tempRes.push(item);
			}
		});
		setList(tempRes);
		onChange(tempRes);
	}

	function onFileChange(id, fileId) {
		let tempRes = [];
		list?.forEach((item) => {
			if (id === item?.id) {
				tempRes.push({
					...item,
					tempFile: fileId,
				});
			} else {
				tempRes.push(item);
			}
		});
		setList(tempRes);
		onChange(tempRes);
	}

	function onPdfChange(id, fileId) {
		let tempRes = [];
		list?.forEach((item) => {
			if (id === item?.id) {
				tempRes.push({
					...item,
					tempPdf: fileId,
				});
			} else {
				tempRes.push(item);
			}
		});
		setList(tempRes);
		onChange(tempRes);
	}

	function onRemoveFile(id) {
		let tempRes = [];
		list?.forEach((item) => {
			if (id === item?.id) {
				tempRes.push({
					...item,
					tempFile: null,
					file: null,
				});
			} else {
				tempRes.push(item);
			}
		});
		setList(tempRes);
		onChange(tempRes);
	}

	function onRemovePdf(id) {
		let tempRes = [];
		list?.forEach((item) => {
			if (id === item?.id) {
				tempRes.push({
					...item,
					tempPdf: null,
					pdf: null,
				});
			} else {
				tempRes.push(item);
			}
		});
		setList(tempRes);
		onChange(tempRes);
	}

	function removeUploadedFile(id) {
		let tempRes = [];
		list?.forEach((item) => {
			if (id === item?.id) {
				tempRes.push({
					...item,
					file: null,
					tempFile: null,
				});
			} else {
				tempRes.push(item);
			}
		});
		setList(tempRes);
		onChange(tempRes);
	}

	function removeUploadedPdf(id) {
		let tempRes = [];
		list?.forEach((item) => {
			if (id === item?.id) {
				tempRes.push({
					...item,
					pdf: null,
					tempPdf: null,
				});
			} else {
				tempRes.push(item);
			}
		});
		setList(tempRes);
		onChange(tempRes);
	}

	function FileTip() {
		const fileModal = useDisclosure();

		return (
			<Popover size="sm" isOpen={fileModal?.isOpen} onClose={fileModal?.onClose} placement="auto">
				<PopoverTrigger>
					<InfoIcon color="gray.400" boxSize="14px" onClick={fileModal?.onOpen} />
				</PopoverTrigger>
				<PopoverContent _focus={{ boxShadow: 'none', outline: 'none' }}>
					<PopoverArrow />
					<PopoverBody>
						<Text fontSize="sm" fontWeight="600" color="gray.600">
							{t('File Type')}
						</Text>
						<UnorderedList>
							<ListItem>
								<Text fontSize="sm" fontWeight="700" color="gray.600">
									{'doc, docx'}
								</Text>
							</ListItem>
							<ListItem>
								<Text fontSize="sm" fontWeight="700" color="gray.600">
									{'xls, xlsx'}
								</Text>
							</ListItem>
							<ListItem>
								<Text fontSize="sm" fontWeight="700" color="gray.600">
									{'ppt, pptx'}
								</Text>
							</ListItem>
						</UnorderedList>
					</PopoverBody>
				</PopoverContent>
			</Popover>
		);
	}

	function PdfTip() {
		const otherModal = useDisclosure();

		return (
			<Popover size="sm" isOpen={otherModal?.isOpen} onClose={otherModal?.onClose} placement="auto">
				<PopoverTrigger>
					<InfoIcon color="gray.400" boxSize="14px" onClick={otherModal?.onOpen} />
				</PopoverTrigger>
				<PopoverContent _focus={{ boxShadow: 'none', outline: 'none' }}>
					<PopoverArrow />
					<PopoverBody>
						<Text fontSize="sm" fontWeight="600" color="gray.600">
							{t('File Type')}
						</Text>
						<UnorderedList>
							<ListItem>
								<Text fontSize="sm" fontWeight="700" color="gray.600">
									{'pdf'}
								</Text>
							</ListItem>
						</UnorderedList>
					</PopoverBody>
				</PopoverContent>
			</Popover>
		);
	}

	function inputItem(item, i, count) {
		return (
			<SimpleGrid key={item?.id} columns={{ base: 1, md: 4 }} spacingX={4} spacingY={1} mb={i === count - 1 ? 0 : 4}>
				<Box>
					<LabelDetail
						direction="column"
						label={showLabel ? 'Label' : null}
						childDetail={<Input mt="1" size="sm" value={item?.label} onChange={(e) => onLabelChange(item?.id, e?.currentTarget.value)} />}
					/>
				</Box>
				<Box>
					<LabelDetail
						direction="column"
						label={showLabel ? 'File (office)' : null}
						childDetail={
							<>
								{item?.file?.url ? (
									<Box ml="-4">
										<WrapItem className="avatarWraper">
											<FontAwesomeIcon
												onClick={() => removeUploadedFile(item?.id)}
												className="remove"
												icon={faMinusSquare}
												style={{
													fontSize: 18,
													display: 'none',
													position: 'absolute',
													zIndex: '100',
													marginLeft: 16,
													color: 'red',
													backgroundColor: 'white',
													padding: 2,
													cursor: 'pointer',
												}}
											/>
											<DownloadAndViewButton url={item?.file?.url} size={item?.file?.size} />
										</WrapItem>
									</Box>
								) : (
									<TempFileUploader
										callBack={(e) => onFileChange(item?.id, e?.id)}
										label={null}
										required={true}
										onCancelFile={() => onRemoveFile(item?.id)}
										callBackUploading={(e) => setUploadingFile(e)}
										disabled={uploadingFile}
										mt={0}
										mb={0}
										size="sm"
										accept=".xls,.xlsx,.doc,.docx,.ppt,.pptx"
									/>
								)}
							</>
						}
						guide={<FileTip />}
					/>
				</Box>
				<Box>
					<LabelDetail
						direction="column"
						label={showLabel ? 'File (pdf)' : null}
						childDetail={
							<>
								{item?.pdf?.url ? (
									<Box ml="-4">
										<WrapItem className="avatarWraper">
											<FontAwesomeIcon
												onClick={() => removeUploadedPdf(item?.id)}
												className="remove"
												icon={faMinusSquare}
												style={{
													fontSize: 18,
													display: 'none',
													position: 'absolute',
													zIndex: '100',
													marginLeft: 16,
													color: 'red',
													backgroundColor: 'white',
													padding: 2,
													cursor: 'pointer',
												}}
											/>
											<DownloadAndViewButton url={item?.pdf?.url} size={item?.pdf?.size} />
										</WrapItem>
									</Box>
								) : (
									<TempFileUploader
										callBack={(e) => onPdfChange(item?.id, e?.id)}
										label={null}
										required={true}
										onCancelFile={() => onRemovePdf(item?.id)}
										callBackUploading={(e) => setUploadingFile(e)}
										disabled={uploadingFile}
										mt={0}
										mb={0}
										size="sm"
										accept="application/pdf"
									/>
								)}
							</>
						}
						guide={<PdfTip />}
					/>
				</Box>
				<Box>
					<Button
						onMouseDown={() => {
							if (item?.tempFile || item?.label || item?.file?.url || item?.pdf?.url) {
								setRemovingId(item?.id);
							} else {
								removeFile(item?.id);
							}
						}}
						colorScheme="blue"
						variant="outline"
						size="sm"
						mt={showLabel ? 5 : 0}
					>
						{t('Remove')}
					</Button>
				</Box>
			</SimpleGrid>
		);
	}

	return (
		<>
			{isEditing ? (
				<Box>
					{showLabel && (
						<Box mt="6">
							<Text mt="4" fontSize="lg" mb="2" fontWeight="bold">
								{t('Other Attachments')}
							</Text>
						</Box>
					)}
					{list.map((item, i) => inputItem(item, i, list?.length))}
					<Button onMouseDown={() => addNewFile()} colorScheme="blue" variant="outline" size="sm" mt={4}>
						{t('Add other attachments')}
					</Button>
				</Box>
			) : (
				<>
					{list?.length > 0 && (
						<Box>
							{showLabel && (
								<Box mt="6">
									<Text mt="4" fontSize="lg" mb="2" fontWeight="bold">
										{t('Other Attachments')}
									</Text>
								</Box>
							)}
							{list?.map((item, i) => {
								return (
									<Box key={i}>
										{(item?.label || item?.file?.url || item?.pdf?.url) && (
											<SimpleGrid spacingX={4} spacingY={1} columns={{ base: 1, md: 3 }} mb={i === list?.length - 1 ? 0 : 4}>
												<LabelDetail
													mt="0"
													mb="0"
													direction="column"
													label="Label"
													guide={null}
													childDetail={<Text>{item?.label}</Text>}
												/>
												{item?.file?.url && (
													<LabelDetail
														mt="0"
														mb="0"
														direction="column"
														label="File (office)"
														guide={<FileTip />}
														childDetail={<DownloadAndViewButton marginLeft={0} url={item?.file?.url} size={item?.file?.size} />}
													/>
												)}
												{item?.pdf?.url && (
													<LabelDetail
														mt="0"
														mb="0"
														direction="column"
														label="File (pdf)"
														guide={<PdfTip />}
														childDetail={<DownloadAndViewButton marginLeft={0} url={item?.pdf?.url} size={item?.pdf?.size} />}
													/>
												)}
											</SimpleGrid>
										)}
									</Box>
								);
							})}
						</Box>
					)}
				</>
			)}
			<AlertDialog isOpen={removingId ? true : false} onClose={() => setRemovingId(null)}>
				<AlertDialogOverlay>
					<AlertDialogContent>
						<AlertDialogHeader fontSize="lg" fontWeight="bold">
							{t('Remove')}
						</AlertDialogHeader>
						<AlertDialogBody>{t('Are you sure to remove other attachments?')}</AlertDialogBody>
						<AlertDialogFooter>
							<Button mr={4} onClick={() => setRemovingId(null)}>
								{t('No')}
							</Button>
							<Button
								colorScheme="red"
								onClick={() => {
									setRemovingId(null);
									removeFile(removingId);
								}}
							>
								{t('Yes')}
							</Button>
						</AlertDialogFooter>
					</AlertDialogContent>
				</AlertDialogOverlay>
			</AlertDialog>
		</>
	);
}
